import Base from '../Pages/Base'
import List from '../Pages/List'
import Form from '../Pages/Form'

export default [
	{
		path: 'links/artistico-literario',
		component: Base,
		children: [
			{
				path: '',
				name: 'ArtisticoLiterarioList',
				component: List,
				meta: {
					path: '/links/artistico-literario',
					pai: 'Links',
					title: 'Admin - Artístico e Literário',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Artístico e Literário',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},
			{
				path: 'novo',
				name: 'ArtisticoLiterarioNovo',
				component: Form,
				meta: {
					path: '/links/artistico-literario',
					pai: 'Links',
					title: 'Admin - Artístico e Literário - Novo',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Artístico e Literário',
						class: '',
						active: false,
						url: '/links/artistico-literario'
					},
					{
						pagina: 'Novo',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},
			{
				path: ':id',
				name: 'ArtisticoLiterarioEditar',
				component: Form,
				meta: {
					path: '/links/artistico-literario',
					pai: 'Links',
					title: 'Admin - Artístico e Literário - Editar',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Artístico e Literário',
						class: '',
						active: false,
						url: '/links/artistico-literario'
					},
					{
						pagina: 'Editar',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			}
		]
	}
]